@let project = project$ | async; @let label = label$ | async;

@if (
  !updatingShiftIds ||
  updatingShiftIds.indexOf(shiftView?.shift?.id || '') === -1
) {
  @if (
    {
      isAssignmentMode: dragAndDropModeService.isAssignmentMode$ | async,
      isMoveMode: dragAndDropModeService.isMoveMode$ | async,
    };
    as data
  ) {
    @if (showActivities) {
      <wilson-timeline-auto-size-shift-with-activities-card
        [shiftView]="shiftView"
        [shift]="shiftView.shift"
        [isShiftDraggable]="shiftView.shift | isShiftDraggable"
        [userId]="userId"
        [showShiftValidation]="showShiftValidation"
        [parentElement]="wrapperEle"
        [isDragging]="draggingItemId === shiftView.shift.id"
        [classPositioning]="{ 'position-relative': true }"
        [filteredActivityId]="draggingItemId"
        [isCursorGrab]="isCursorGrab"
        [isActivityDraggable]="isActivityDraggable"
        [shiftStartDetail]="shiftStartDetail"
        [shiftEndDetail]="shiftEndDetail"
        [isTooltipVisible]="true"
        [isShiftVisible]="true"
        [leftPixelPosition]="leftPixelPosition$ | async"
        [rightPixelPosition]="rightPixelPosition$ | async"
        (selectShift)="selectedShift($event)"
        (selectActivity)="selectActivityEvent.emit($event)"
      ></wilson-timeline-auto-size-shift-with-activities-card>
    } @else {
      <wilson-shift-card
        [shift]="shiftView.shift"
        [showShiftValidation]="showShiftValidation"
        [isShiftDraggable]="shiftView.shift | isShiftDraggable"
        [userId]="userId"
        [isDragging]="draggingItemId === shiftView.shift.id"
        [isMoveMode]="data.isMoveMode"
        [isFiltered]="!shiftView.shift.isHighlighted"
        [isTooltipVisible]="true"
        [isShiftVisible]="true"
        [shiftStartDetail]="shiftStartDetail"
        [shiftEndDetail]="shiftEndDetail"
        [leftPixelPosition]="leftPixelPosition$ | async"
        [rightPixelPosition]="rightPixelPosition$ | async"
        (selectShift)="selectedShift($event)"
      ></wilson-shift-card>
    }
  }
} @else {
  @if (
    {
      shiftStartTime: (shiftView.shift.activities | ganttShiftStartTime),
      shiftEndTime: shiftView.shift.activities | ganttShiftEndTime,
    };
    as shiftTimeData
  ) {
    <wilson-loading-shift-card
      [shift]="shiftView.shift"
      [shiftStartTime]="shiftTimeData.shiftStartTime.date"
      [shiftEndTime]="shiftTimeData.shiftEndTime.date"
      [project]="project"
      [label]="label"
    ></wilson-loading-shift-card>
  }
}

<div id="move-activity" class="move-preview" #dragImage></div>
